<template>
  <div class="saved-words">
    <!-- <ChapterHeader title=" מילים שמורות" /> -->
    <!-- <ChapterVocabulary title="מילים שמורות" :words="savedWords" /> -->
    <!-- <div class="savedTitle">מילים שמורות ({{ savedWords.length }})</div> -->
    <div class="loader" v-if="isLoading">
      {{ $t("savedWords.savedWords.loading") }}
      <div
        style="text-align: center; display: flex; justify-content: center; margin: 8px;"
      >
        <SlinkyVue />
      </div>
    </div>
    <div v-if="!user">
      <p style="margin: 40px; text-align: center;">
        {{ $t("savedWords.savedWords.register-only") }}
      </p>
      <LoginButton />
    </div>
    <div class="wordsExp" v-if="!isLoading">
      <v-expansion-panel v-if="savedWords" v-model="value" focusable>
        <v-expansion-panel-content v-if="user">
          <template v-slot:header>
            <div class="expHeader">
              {{ $t("savedWords.savedWords.saved") }}({{ savedWords.length }})
            </div>
            <div class="expIcon">
              <inline-svg
                class="saveSvg saveWord savedWord"
                :src="require('../../assets/svg/saved.svg').default"
              ></inline-svg>
            </div>
          </template>
          <v-card>
            <v-card-text class="expContent">
              <div v-if="user">
                <div
                  class="word"
                  v-for="(word, idx) in savedWords"
                  :key="word.objectID"
                >
                  <!-- <div class="idx">{{ idx + 1 }}</div> -->
                  <button class="btn-remove" @click="removeWord(word)">
                    <inline-svg
                      class="saveSvg saveWord"
                      :class="{ savedWord: isSaved(word) }"
                      :src="
                        isSaved(word)
                          ? require('../../assets/svg/saved.svg').default
                          : require('../../assets/svg/notsaved.svg').default
                      "
                    ></inline-svg>
                    {{ $t("savedWords.savedWords.remove") }}
                  </button>
                  <div class="translations" ref="translations">
                    <span class="arbT">{{ word.Eng }}</span>
                    <span class="heb" :style="{ direction: destLlr ? 'ltr' : 'rtl' }" >{{ word.heb }}</span>
                  </div>

                  <!-- <ProgressBar
            v-if="removeOrProgress === 'progress'"
            class="word-left"
            :progress="word.know"
            :max="5"
          /> -->
                  <div class="word-left">
                    <inline-svg
                      v-if="!word.know"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup0.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 1"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup1.svg').default"
                    ></inline-svg>

                    <inline-svg
                      v-if="word.know == 2"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup2.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 3"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup3.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 4"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup4.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know >= 5"
                      class="progress-icon"
                      :src="
                        require('../../assets/svg/progress-100.svg').default
                      "
                    ></inline-svg>
                  </div>
                  <div class="audio">
                    <AudioBtn :urlId="word.id" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content v-if="user">
          <!-- <v-expansion-panel-content v-for="(item, i) in 5" :key="i"> -->
          <template v-slot:header>
            <div class="expHeader">
              {{ $t("savedWords.savedWords.memorization") }}({{
                processWords.length
              }})
            </div>
            <div class="expIcon">
              <!-- <inline-svg
              class="progress-icon"
              :src="require('../../assets/svg/Cup1.svg').default"
            ></inline-svg>
            <inline-svg
              class="progress-icon"
              :src="require('../../assets/svg/Cup2.svg').default"
            ></inline-svg> -->
              <inline-svg
                class="progress-icon"
                :src="require('../../assets/svg/Cup2.svg').default"
              ></inline-svg>
            </div>
          </template>
          <v-card>
            <v-card-text class="expContent">
              <div v-if="user">
                <div
                  class="word"
                  v-for="(word, idx) in processWords"
                  :key="word.objectID"
                >
                  <!-- <div class="idx">{{ idx + 1 }}</div> -->
                  <button
                    class="btn-remove"
                    v-if="isSaved(word)"
                    @click="removeWord(word)"
                  >
                    <inline-svg
                      class="saveSvg saveWord savedWord"
                      :src="require('../../assets/svg/saved.svg').default"
                    ></inline-svg>
                    {{ $t("savedWords.savedWords.remove") }}
                  </button>
                  <button
                    class="btn-remove"
                    v-if="!isSaved(word)"
                    @click="addWord(word)"
                  >
                    <inline-svg
                      class="saveSvg saveWord"
                      :src="require('../../assets/svg/notsaved.svg').default"
                    ></inline-svg>
                    {{ $t("savedWords.savedWords.save") }}
                  </button>
                  <div class="translations" ref="translations">
                    <span class="arbT">{{ word.Eng }}</span>
                    <span class="heb" :style="{ direction: destLlr ? 'ltr' : 'rtl' }" >{{ word.heb }}</span>
                  </div>

                  <!-- <ProgressBar
            v-if="removeOrProgress === 'progress'"
            class="word-left"
            :progress="word.know"
            :max="5"
          /> -->
                  <div class="word-left">
                    <inline-svg
                      v-if="!word.know"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup0.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 1"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup1.svg').default"
                    ></inline-svg>

                    <inline-svg
                      v-if="word.know == 2"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup2.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 3"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup3.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 4"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup4.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know >= 5"
                      class="progress-icon"
                      :src="
                        require('../../assets/svg/progress-100.svg').default
                      "
                    ></inline-svg>
                  </div>
                  <div class="audio">
                    <AudioBtn :urlId="word.id" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <!-- full -->
        <v-expansion-panel-content v-if="user">
          <template v-slot:header>
            <div class="expHeader">
              {{ $t("savedWords.savedWords.memorization2") }}({{
                fullWords.length
              }})
            </div>
            <div class="expIcon">
              <inline-svg
                class="progress-icon"
                :src="require('../../assets/svg/Cup4.svg').default"
              ></inline-svg>
            </div>
          </template>
          <v-card>
            <v-card-text class="expContent">
              <div v-if="user">
                <div
                  class="word"
                  v-for="(word, idx) in fullWords"
                  :key="word.objectID"
                >
                  <!-- <div class="idx">{{ idx + 1 }}</div> -->
                  <button
                    class="btn-remove"
                    v-if="isSaved(word)"
                    @click="removeWord(word)"
                  >
                    <inline-svg
                      class="saveSvg saveWord savedWord"
                      :src="require('../../assets/svg/saved.svg').default"
                    ></inline-svg>
                    {{ $t("savedWords.savedWords.remove") }}
                  </button>
                  <button
                    class="btn-remove"
                    v-if="!isSaved(word)"
                    @click="addWord(word)"
                  >
                    <inline-svg
                      class="saveSvg saveWord"
                      :src="require('../../assets/svg/notsaved.svg').default"
                    ></inline-svg>
                    {{ $t("savedWords.savedWords.save") }}
                  </button>
                  <div class="translations" ref="translations">
                    <span class="arbT">{{ word.Eng }}</span>
                    <span class="heb" :style="{ direction: destLlr ? 'ltr' : 'rtl' }" >{{ word.heb }}</span>
                  </div>

                  <!-- <ProgressBar
            v-if="removeOrProgress === 'progress'"
            class="word-left"
            :progress="word.know"
            :max="5"
          /> -->
                  <div class="word-left">
                    <inline-svg
                      v-if="!word.know"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup0.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 1"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup1.svg').default"
                    ></inline-svg>

                    <inline-svg
                      v-if="word.know == 2"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup2.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 3"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup3.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 4"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup4.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know >= 5"
                      class="progress-icon"
                      :src="
                        require('../../assets/svg/progress-100.svg').default
                      "
                    ></inline-svg>
                  </div>
                  <div class="audio">
                    <AudioBtn :urlId="word.id" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <!-- groups -->
        <v-expansion-panel-content v-for="group in groups" :key="group.name">
          <template v-slot:header>
            <div class="expHeader">{{ group.name }}</div>
          </template>
          <v-card>
            <v-card-text class="expContent">
              <div>
                <div
                  class="word"
                  v-for="(word, idx) in group.words"
                  :key="word.objectID"
                >
                  <!-- <div class="idx">{{ idx + 1 }}</div> -->
                  <button
                    class="btn-remove"
                    v-if="isSaved(word)"
                    @click="removeWord(word)"
                  >
                    <inline-svg
                      class="saveSvg saveWord savedWord"
                      :src="require('../../assets/svg/saved.svg').default"
                    ></inline-svg>
                    {{ $t("savedWords.savedWords.remove") }}
                  </button>
                  <button
                    class="btn-remove"
                    v-if="!isSaved(word)"
                    @click="addWord(word)"
                  >
                    <inline-svg
                      class="saveSvg saveWord"
                      :src="require('../../assets/svg/notsaved.svg').default"
                    ></inline-svg>
                    {{ $t("savedWords.savedWords.save") }}
                  </button>

                  <div class="translations" ref="translations">
                    <span class="arbT">{{ word.Eng }}</span>
                    <span class="heb" :style="{ direction: destLlr ? 'ltr' : 'rtl' }">{{ word.heb }} </span>
                  </div>

                  <div class="word-left">
                    <inline-svg
                      v-if="!word.know"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup0.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 1"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup1.svg').default"
                    ></inline-svg>

                    <inline-svg
                      v-if="word.know == 2"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup2.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 3"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup3.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know == 4"
                      class="progress-icon"
                      :src="require('../../assets/svg/Cup4.svg').default"
                    ></inline-svg>
                    <inline-svg
                      v-if="word.know >= 5"
                      class="progress-icon"
                      :src="
                        require('../../assets/svg/progress-100.svg').default
                      "
                    ></inline-svg>
                  </div>
                  <div class="audio">
                    <AudioBtn :urlId="word.id" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
    <v-snackbar
      v-model="snackbar"
      :bottom="false"
      :left="false"
      :multi-line="true"
      :right="false"
      :timeout="2000"
      :top="true"
      :vertical="true"
    >
      שומר מילה
      <div class="snackBtns">
        <v-btn color="white" flat @click="snackbar = false">
          סגירה
        </v-btn>
      </div>
    </v-snackbar>
    <button
      :style="safeBottomVarBtn"
      class="playBtn"
      :disabled="value === null"
      @click="goPlay"
    >
      {{ $t("savedWords.savedWords.play") }}
    </button>
  </div>
</template>

<script>
import "./saved-words.scss";
import ChapterHeader from "../chapter/chapter-header";
import LoginButton from "../User/LoginButton.vue";
import { wordService } from "../../services/wordService";
import Spacer from "../Shared/Spacer.vue";
import AudioBtn from "../Shared/audioBtnNoPreLoad.vue";
import { userService } from "../../services/userService";
import SlinkyVue from "../Shared/Slinky.vue";
export default {
  name: "saved-words",
  data() {
    return {
      savedWords: [],
      knownWords: [],
      GroupWords: [],
      snackbar: false,
      isLoading: true,
      exp: true,
      value: null,
      groupsDone: false,
      mygroups: [],
      destLlr: localStorage.getItem("destDirection") == "ltr",
    };
  },
  async mounted() {
    console.log("clicked words");
    this.isLoading = true;
    await new Promise(r => setTimeout(r, 1000));

    //need loader for words
    if (this.user) {
      this.savedWords = await wordService.getSavedWords(this.user);
      this.knownWords = await wordService.getKnownWords(this.user);
      // this.GroupWords = await wordService.getGroupWords("food");
      // console.log(this.savedWords);
    }
    this.isLoading = false;
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    safeBottomVarBtn() {
      return {
        "--bottomBtn": this.$store.getters.safeBottom + 88 + "px"
      };
    },
    words() {
      return this.$store.getters.words;
    },
    word_groups() {
      return this.$store.getters.word_groups;
    },
    groups() {
      const words = this.$store.getters.word_groups_words;
      if (words && words.length) {
        console.log("NOT AGAIN");
        return words;
      }
      //const grps = this.groupBy(this.words, "group");
      //this.groupsDone = true;
      //console.log(grps);
      let group_words = [];
      this.word_groups.forEach(res => {
        const name = res.name;
        const groupid = res.wordgroup;
        //console.log(groupid);
        const groupWords = this.words.filter(word => word.group === groupid);
        //console.log(grps[groupid]);
        // const groupWords = grps[groupid] ? grps[groupid] : [];
        // const groupWords = [];
        let groupWordsWithKnown = groupWords;
        if (this.user) groupWordsWithKnown = this.getKnow(groupWords);
        if (groupWordsWithKnown.length)
          group_words.push({
            id: groupid,
            name: name,
            words: groupWordsWithKnown
          });
      });

      return group_words;
    },
    processWords() {
      if (this.user && this.knownWords) {
        return this.knownWords.filter(res => res.know != 0 && res.know != 4);
      }
    },
    fullWords() {
      if (this.user && this.knownWords) {
        return this.knownWords.filter(res => res.know === 4);
      }
    }
    // savedWords() {
    //   return this.$store.getters.savedWords;
    // }
  },
  watch: {
    async user() {
      if (!this.savedWords.length || !this.knownWords.length) {
        console.log("BAH");
        this.savedWords = await wordService.getSavedWords(this.user);
        this.knownWords = await wordService.getKnownWords(this.user);
      }
      // this.mygroups = await this.groups();
      this.isLoading = false;
    },
    groups() {
      console.log(this.groups);
      this.$store.commit("setWordGroupsWords", this.groups);
    }
  },
  methods: {
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    // groups() {
    //   //const grps = this.groupBy(this.words, "group");
    //   //this.groupsDone = true;
    //   //console.log(grps);
    //   let group_words = [];
    //   this.word_groups.forEach(res => {
    //     const name = res.name;
    //     const groupid = res.wordgroup;
    //     //console.log(groupid);
    //     const groupWords = this.words.filter(word => word.group === groupid);
    //     //console.log(grps[groupid]);
    //     // const groupWords = grps[groupid] ? grps[groupid] : [];
    //     // const groupWords = [];
    //     let groupWordsWithKnown = groupWords;
    //     if (this.user) groupWordsWithKnown = this.getKnow(groupWords);
    //     if (groupWordsWithKnown.length)
    //       group_words.push({
    //         id: groupid,
    //         name: name,
    //         words: groupWordsWithKnown
    //       });
    //   });
    //   return group_words;
    // },
    async removeWord(word) {
      this.savedWords = this.savedWords.filter(item => item.id !== word.id);
      await userService.unsaveWord(word.id);
    },
    async addWord(word) {
      // this.snackbar = true;
      this.savedWords.push(word);
      await userService.saveWord(word.id);
    },
    isSaved(word) {
      if (this.user && this.savedWords && this.savedWords.length) {
        if (this.savedWords.filter(res => res.id === word.id).length)
          return true;
        return false;
      }
    },
    goPlay() {
      console.log(this.value);
      if (this.user) {
        if (this.value === null) return;
        if (this.value === 0 && this.savedWords.length > 0) {
          this.$router.push("/game/savedwords");
        }
        if (this.value === 1 && this.processWords.length > 0)
          this.$router.push("/game/processwords");
        if (this.value === 2 && this.fullWords.length > 0)
          this.$router.push("/game/fullwords");
        this.$router.push({
          path: "/game/group",
          query: {
            id: this.groups[this.value - 3].id,
            name: this.groups[this.value - 3].name
          }
        });
      } else {
        this.$router.push({
          path: "/game/group",
          query: {
            id: this.groups[this.value].id,
            name: this.groups[this.value].name
          }
        });
      }
    },
    getKnow(words) {
      let new_words = [];
      new_words = words.map(w => {
        if (
          this.knownWords &&
          this.knownWords.length &&
          this.knownWords.find(kw => kw.id === w.id)
        ) {
          w.know = this.knownWords.find(kw => kw.id === w.id).know || 0;
        } else {
          w.know = 0;
        }
        return w;
      });
      // this.knownWords.forEach(kw => {
      //   new_words = words.map(w => {
      //     if (kw.id === w.id) {
      //       w.know = kw.know || 0;
      //     }
      //     return w;
      //   });
      // });
      return new_words;
    }
  },
  components: {
    ChapterHeader,
    LoginButton,
    Spacer,
    AudioBtn,
    SlinkyVue
  }
};
</script>

<style scoped>
/* .saved-words {
  margin-bottom: 125px;
} */
.wordsExp {
  overflow: scroll;
  height: calc(100vh - 150px);
}
li:last-child {
  margin-bottom: 125px;
}
.progress-icon {
  height: 24px;
}
.translations {
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  width: 55%;
  text-align: center;
}
.word {
  border-bottom: 1px solid #dddddd;
  display: flex;
  height: 74px;
  align-items: center;
  justify-content: space-around;
}
.btn-remove {
  /* border: 0.5px solid black; */
  font-size: 12px;
  border-radius: 14px;
  /* padding: 4px; */
  margin: -3px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 10%;
  align-self: flex-start;
}
.idx {
  margin: 0 12px;
  width: 0.5em;
}
.audio {
  display: grid;
  margin-right: 6px;
  margin-left: 4px;
}

.savedTitle {
  text-align: center;
  height: 74px;
  width: 100%;
  border-bottom: 1px solid black;
}
span {
  font-size: 18px;
}
.loader {
  text-align: center;
  margin: 30px 30px;
}
.expHeader {
  font-size: 18px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
}
.expContent {
  font-size: 20px;
}
.saveWord {
  fill: white;
}
.savedWord {
  fill: #ff6485;
}
.saveSvg {
  width: 20px;
}
.playBtn {
  transition: opacity 200ms ease-in;
  width: 90%;
  background-color: #555fff;
  color: white;
  text-align: center;
  height: 60px;
  font-size: 26px;
  position: fixed;
  bottom: var(--bottomBtn);
  z-index: 5;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0 0 0 20px white;
}
.playBtn:disabled {
  /* background-color: gray; */
  opacity: 0;
}
@media (min-width: 780px) {
  .playBtn {
    width: 60%;
  }
}
.word-left {
  display: grid;
}
.heb {
  color: #555fff;
}
.expIcon {
  margin-left: 8px;
}
.noShow {
  display: none;
}
</style>



// WEBPACK FOOTER //
// SavedWords.vue?156d2c3a